import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";

export function Navbar() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const handleStartBuilding = async () => {
    setIsLoading(true);
    try {
      const { site } = await api.createSite();
      navigate(`/build/${site.id}`);
    } catch (error) {
      console.error("Failed to create site:", error);
      setIsLoading(false);
    }
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50">
      {/* Glass background with fade */}
      <div className="absolute inset-0 bg-background/80 backdrop-blur-md border-b border-primary/5 supports-[backdrop-filter]:bg-background/50" />
      
      <div className="relative mx-auto max-w-6xl px-6 h-20 flex items-center justify-between">
        {/* Logo */}
        <a href="/" className="group flex items-center gap-2">
          <span className="font-display text-2xl font-medium tracking-tight text-primary">
            ImOnSite
          </span>
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8">
          <a
            href="#how-it-works"
            className="text-sm font-medium text-muted-foreground hover:text-primary transition-colors"
          >
            How it works
          </a>
          <a
            href="#pricing"
            className="text-sm font-medium text-muted-foreground hover:text-primary transition-colors"
          >
            Pricing
          </a>
        </div>

        {/* CTA */}
        <Button 
          onClick={handleStartBuilding}
          disabled={isLoading}
          className="rounded-full h-10 px-6 bg-primary text-primary-foreground hover:bg-primary/90 font-medium text-sm transition-all hover:scale-105 disabled:opacity-70"
        >
          {isLoading ? (
            <>
              <Loader2 className="mr-2 size-4 animate-spin" />
              Creating...
            </>
          ) : (
            "Build my website"
          )}
        </Button>
      </div>
    </nav>
  );
}

